import React, { useState } from 'react'

import { HiMenuAlt2 } from 'react-icons/hi'
import { GoSearch } from 'react-icons/go'
import { BiUserCircle } from 'react-icons/bi'
import { FiLogOut } from 'react-icons/fi'
import { BsGear } from 'react-icons/bs'

import { useForm } from 'react-hook-form'

import { useMenu } from '../../../hooks/useMenu'

import styles from './styles.module.scss'
import './input.scss'
import { motion, useAnimation } from 'framer-motion'
import { useUser } from '../../../hooks/useLogin'

type HeaderProps = {
    gridAppStyle: () => void;
}

type Search = {
    SearchText: string
}

export function Header(props: HeaderProps) {

    const { toggleMenu } = useMenu()

    const {
        handleSubmit,
    } = useForm<Search>({ mode: "onChange" })

    const [searchValue, setSearchValue] = useState('')

    function onSubmit() {
        window.location.pathname = `${process.env.REACT_APP_BASE_URL}/resultado/${searchValue.replaceAll(' ', '+')}`
    }

    const [circleMenuStatus, setCircleMenuStatus] = React.useState(styles.circleIconMenuBorderOff)
    const [circleMenuFillStatus, setCircleMenuFillStatus] = React.useState(styles.circleIconMenuFillOff)

    function handleChangeMenu() {
        toggleMenu()
        props.gridAppStyle()

        setCircleMenuFillStatus(styles.circleIconMenuFill)
        setTimeout(function () { setCircleMenuFillStatus(styles.circleIconMenuFillOff) }, 150)
        setTimeout(function () { setCircleMenuStatus(styles.circleIconMenuBorder) })
        setTimeout(function () { setCircleMenuStatus(styles.circleIconMenuBorderOff) }, 250)
    }

    const userOptionsAnimation = useAnimation()

    let [statusButtonUser, setStatusButtonUser] = React.useState(false)

    function setMotionsForm(element: string) {

        if (element === 'userButton') {
            if (!statusButtonUser) {
                userOptionsAnimation.start({
                    opacity: 1,
                    visibility: 'visible'
                })
            } else {
                userOptionsAnimation.start({
                    opacity: 0,
                    visibility: 'hidden'
                })
            }
        }

        setStatusButtonUser(!statusButtonUser)
    }

    function handleGoToAdmin() {
        window.location.pathname = `${process.env.REACT_APP_BASE_URL}/admin`
    }

    function handleLogout() {
        localStorage.setItem('userData', 'vazio')
        window.location.pathname = `/${process.env.REACT_APP_BASE_URL}`
        localStorage.removeItem('userData')
    }

    const { userStatus } = useUser()

    return (
        <div className={styles.Header}>
            <div className={styles.flexContainer}>
                <div>
                    <div className={styles.HeaderMenuContainer}>
                        <div
                            className={`${styles.iconMenuContainer} ${circleMenuFillStatus} ${circleMenuStatus}`}
                            onClick={handleChangeMenu}>
                            <HiMenuAlt2 />
                        </div>
                        <h1>
                            <span style={{ color: 'rgb(39,84,168)', marginRight: '5px' }}>
                                Guia
                            </span>
                            <span style={{ color: '#8f8f8f', marginRight: '5px' }}>De</span>
                            <span style={{ color: '#8f8f8f' }}>
                                Referências
                            </span></h1>
                    </div>
                </div>
                <form action="" onSubmit={handleSubmit(onSubmit)}>
                    <div className={styles.InputContainer}>
                        <input type="text" placeholder="Pesquisar..." className={styles.InputSearch} onChange={(element) => setSearchValue(element.target.value)} />
                        <button type="submit" className={styles.InputButton}>
                            <GoSearch style={{ color: '#ffffff', fontSize: '23px' }} />
                        </button>
                        <div className={styles.userIcon} onClick={() => setMotionsForm('userButton')} style={{ display: !userStatus ? 'none' : 'block' }} >
                            <BiUserCircle style={{ color: 'rgb(143, 143, 143)', fontSize: '35px', float: 'right' }} />
                        </div>
                    </div>
                </form>
                <motion.div
                    className={styles.userOptions}
                    animate={userOptionsAnimation}
                    transition={{ duration: 0.3 }}>
                    <div onClick={handleGoToAdmin}>
                        <li>
                            Admin
                            <BsGear style={{ color: 'rgb(143, 143, 143)', fontSize: '20px' }} />
                        </li>
                    </div>
                    <hr />
                    <div onClick={handleLogout}>
                        <li>
                            Sair
                            <FiLogOut style={{ color: 'rgb(143, 143, 143)', fontSize: '20px' }} />
                        </li>
                    </div>
                </motion.div>
            </div>
        </div>
    )
}